import React, { FunctionComponent, ReactElement, memo } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Touchable from '@sport1/react-elements/Touchable'

type VideoControlProp = {
    name: string
    color: string
    fontSize: number
    onPress?: () => void
    marginLeft?: number
    marginRight?: number
    opacity?: number
}

const VideoControl: FunctionComponent<VideoControlProp> = ({
    name,
    onPress,
    color,
    fontSize,
    marginLeft = 0,
    marginRight = 0,
    opacity,
}): ReactElement => {
    const fontelloIcon = (
        <FontelloIcon
            name={name}
            color={color}
            fontSize={fontSize}
            marginLeft={marginLeft}
            marginRight={marginRight}
            opacity={opacity}
        />
    )
    return onPress ? <Touchable onPress={onPress}>{fontelloIcon}</Touchable> : fontelloIcon
}

export default memo(VideoControl)
